import * as React from 'react'
import Grid from '@mui/material/Grid';
import { Button, FormControl, FormControlLabel, Stack, Switch, TextField, Typography, useTheme } from '@mui/material';
import { useLoaderData, useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup"
import UnstyledLink from '../../components/common/UnstyledLink/UnstyledLink';
import { assetsApi, usersApi } from '../../api-interface';
import { useContext, useState } from 'react';
import { TenantContext } from '../..';
import { useSnackbar } from 'notistack';


const AssetAdd = () => {

    const { enqueueSnackbar } = useSnackbar();

    const currentTenant = useContext(TenantContext)
    const navigate = useNavigate()

    const schema = yup
        .object({
            address_1: yup.string().required(),
            address_2: yup.string(),
            city: yup.string(),
            county: yup.string(),
            postcode: yup.string().required(),
        })
        .required()

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    })

    const [apiError, setApiError] = useState<string>("")
    const theme = useTheme()

    const handleNewAsset = async (x) => {
        try {
            await assetsApi(currentTenant).createAssetAssetsNewPost(
                x.address_1,
                x.address_2,
                x.city,
                x.county,
                x.postcode
            )
            enqueueSnackbar('Asset added', { variant: "success" })
            navigate("/dashboard/" + currentTenant + "/assets")
        } catch (e) {
            if (e?.response?.data?.detail) {
                setApiError(e.response.data.detail)
            } else {
                enqueueSnackbar("Error: " + e, { variant: "error" })
            }
        }
    }


    return (
        <Grid size={{xs:11}}>
            <Grid rowSpacing={2} container>
                <Grid size={{xs:12}}>
                    <Typography variant="h4" > Add new Asset </Typography>
                </Grid>
                <Grid size={{xs:12, sm: 12, md: 12, lg:8, xl:4}}>
                    <form onSubmit={handleSubmit(handleNewAsset)}>
                        <FormControl fullWidth>
                            <Typography marginTop={3} variant='subtitle1'>Asset Details</Typography>
                            <TextField
                                margin="normal"
                                label="Address 1"
                                placeholder="Address 1"
                                {...register('address_1')}
                                error={errors.address_1 ? true : false}
                                helperText={errors.address_1?.message?.toString()}
                                type="text"
                                variant='outlined'
                                required
                            />
                            <TextField
                                margin="normal"
                                label="Address 2"
                                placeholder="Address 2"
                                {...register('address_2')}
                                error={errors.address_2 ? true : false}
                                helperText={errors.address_2?.message?.toString()}
                                type="text"
                                variant='outlined'
                            />
                            <TextField
                                margin="normal"
                                label="Town / City"
                                placeholder="Town / City"
                                {...register('city')}
                                error={errors.city ? true : false}
                                helperText={errors.city?.message?.toString()}
                                type="text"
                                variant='outlined'
                            />
                            <TextField
                                margin="normal"
                                label="County"
                                placeholder="County"
                                {...register('county')}
                                error={errors.county ? true : false}
                                helperText={errors.city?.message?.toString()}
                                type="text"
                                variant='outlined'
                            />
                            <TextField
                                margin="normal"
                                label="Postcode"
                                placeholder="Postcode"
                                {...register('postcode')}
                                error={errors.postcode ? true : false}
                                helperText={errors.postcode?.message?.toString()}
                                type="text"
                                variant='outlined'
                                required
                            />
                        </FormControl>
                        <FormControl>
                            <Typography mt={2} color={theme.palette.error.main} display={apiError ? "block" : "none"}>
                                {apiError}
                            </Typography>
                            <Stack marginTop={5} spacing={2} direction="row">
                                <UnstyledLink to=".." relative="path"><Button variant="outlined" >Cancel</Button></UnstyledLink>
                                <Button variant="contained" type="submit">Save</Button>
                            </Stack>

                        </FormControl>

                    </form>

                </Grid>
            </Grid>
        </Grid>
    )
}

export default AssetAdd